import React from 'react'
import StepperBar from './StepperBar'
import ClubAboutGame from '../club/ClubAboutGame'

const SetupProgress = () => (
  <>
    <StepperBar activeStepKey="about_game" />
    <ClubAboutGame />
  </>
)

export default SetupProgress
